/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import 'moment-timezone';

import {pickerDateFromApiInstant} from '../../app/common/locale/network-date-picker-utils';
import {LocalNetworkProfile} from '../session/local-network-profile';

@Injectable({
  providedIn: 'root'
})
export class AdnTimeShifterService {
  constructor(private readonly LocalNetworkProfile: LocalNetworkProfile) {
  }

  startAndEndOfDays(startDate: any, endDate: any): {startDate: Date; endDate: Date} {
    const networkTimezone = this.getNetworkTimezone();
    const startDateString = moment(startDate).format('YYYY-MM-DD');
    const endDateString = moment(endDate).format('YYYY-MM-DD');
    const nowDateString = moment().format('YYYY-MM-DD');
    const timelessTimezonedStartDate = moment.tz(startDateString, networkTimezone);
    const timelessTimezonedEndDate = moment.tz(endDateString, networkTimezone);
    const timelessTimezonedNow = moment.tz(nowDateString, networkTimezone);
    const correctStartDate = timelessTimezonedStartDate.startOf('day');
    const nowRemainder = 30 - (moment().tz(networkTimezone).minute() % 30);
    const correctEndDate = timelessTimezonedEndDate.isSame(timelessTimezonedNow)
      ? moment().tz(networkTimezone).add(nowRemainder, 'minutes')
      : timelessTimezonedEndDate.endOf('day');
    return {
      startDate: pickerDateFromApiInstant(correctStartDate.toDate(), this),
      endDate: pickerDateFromApiInstant(correctEndDate.toDate(), this)
    };
  }

  getNetworkTimezone(): string {
    return this.LocalNetworkProfile.get('timeZone') || 'utc';
  }

  getMomentInNetworkTimezone(theDate?: any): moment.Moment {
    return moment(theDate || moment()).tz(this.getNetworkTimezone());
  }

  timeShift(theDate: any, toBrowserTime?: boolean): Date {
    const timeZone = this.getNetworkTimezone();
    const preferredTz = moment(theDate).tz(timeZone).utcOffset();
    const browserTz = moment(theDate).utcOffset();
    return moment(theDate).add((preferredTz - browserTz) * (toBrowserTime ? -1 : 1), 'minute').toDate();
  }
}
